import React from 'react';
import clsx from 'clsx';
import { IconDefinition } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faXmark } from '@fortawesome/pro-light-svg-icons/faXmark';
import { TypedMemo } from '../../../types';
import { ConfirmDialogTone } from './ConfirmDialogProps';
/* eslint-disable css-modules/no-unused-class -- one stylesheet for the dialog and its marks; each part uses its own slice of it */
import styles from './ConfirmDialog.module.scss';
/* eslint-enable css-modules/no-unused-class */

interface ConfirmDialogIconMarkProps {
  tone: ConfirmDialogTone;
  icon: IconDefinition;
}

/** A tinted icon well: red for a destructive confirm, the soft brand tint for a neutral one (a3, a4). */
const ConfirmDialogIconMarkComponent: React.FC<ConfirmDialogIconMarkProps> = ({ tone, icon }) => (
  <span className={clsx(styles.iconMark, tone === 'danger' ? styles.iconMarkDanger : styles.iconMarkNeutral)}>
    <FontAwesomeIcon icon={icon} />
  </span>
);

export const ConfirmDialogIconMark = TypedMemo(ConfirmDialogIconMarkComponent);

interface ConfirmDialogTileMarkProps {
  /** The thing the action is about: a platform icon, an app mark, initials. */
  children: React.ReactNode;
  /** The tile's fill, for a platform colour. Without it the tile is a plain raised surface. */
  background?: string;
  /** A small red cross on the corner: the action removes this thing (a1). */
  withRemoveBadge?: boolean;
}

/** The tile of the channel, app or service the confirm is about (a1, a5). */
const ConfirmDialogTileMarkComponent: React.FC<ConfirmDialogTileMarkProps> = ({
  children,
  background,
  withRemoveBadge = false,
}) => (
  <span
    className={clsx(styles.tileMark, background !== undefined && styles.tileMarkFilled)}
    style={background === undefined ? undefined : { background }}
  >
    {children}
    {withRemoveBadge && (
      <span className={styles.removeBadge} aria-hidden="true">
        <FontAwesomeIcon icon={faXmark} />
      </span>
    )}
  </span>
);

export const ConfirmDialogTileMark = TypedMemo(ConfirmDialogTileMarkComponent);
